// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import TranslatedOption from '../../../shared/components/translated-option';

const ResponsibleDealerReportLatestDataCriteria = props =>
    <div className='responsible-dealer-report-latest-data-criteria'>
        <h3>
            <FormattedMessage id={props.label}/>
        </h3>
        <select
            onChange={props.onLatestInputChange}
            value={props.isLatest}
        >
            <TranslatedOption
                text='YES'
                value={true}
            />
            <TranslatedOption
                text='NO'
                value={false}
            />
        </select>
    </div>;

ResponsibleDealerReportLatestDataCriteria.displayName = 'ResponsibleDealerReportLatestDataCriteria';
ResponsibleDealerReportLatestDataCriteria.propTypes = {
    isLatest: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired,
    onLatestInputChange: PropTypes.func.isRequired
};

export default ResponsibleDealerReportLatestDataCriteria;



// WEBPACK FOOTER //
// ./src/reports/responsible-dealer/components/responsible-dealer-report-latest-data-criteria.js